/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SubscriberCancellationDetail {
  active?: boolean;
  boxId?: string;
  cancellationReason?: string;
  cancellationReasonId?: number;
  cancellationReference?: number;
  cancellationType?: number;
  cancelledBy?: string;
  chargeAmount?: number;
  dateCancelled?: Date;
  dateExecuted?: Date;
  dateSyncERP?: string;
  editionCancelled?: number;
  fee?: number;
  refundAmount?: number;
  shippingName?: string;
  subscriberCancellationId?: number;
  subscriberCancellationReasonName?: string;
  subscriberControlId?: number;
  subscriberId?: number;
}
